import { render } from "./AssTeacherMaster.vue?vue&type=template&id=3792785c&scoped=true"
import script from "./AssTeacherMaster.vue?vue&type=script&lang=js"
export * from "./AssTeacherMaster.vue?vue&type=script&lang=js"

import "./AssTeacherMaster.vue?vue&type=style&index=0&id=3792785c&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3792785c"]])

export default __exports__